<template>
  <b-container class="bv-example-row">
    <b-row>
      <b-col class="border" sm="3">
        <b-button variant="warning" size="lg"> Si Kuning</b-button>
      </b-col>
      <b-col class="border" sm="6"><b-button size="lg">Si Merah</b-button></b-col>
      <b-col class="border" sm="3"><b-button variant="danger" size="lg">Si Merah</b-button></b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {};
</script>
